// extracted by mini-css-extract-plugin
module.exports = {"button":"button-3N2cO","pill-span":"pill-span-1wHOl","pillSpan":"pill-span-1wHOl"};